module.exports = __webpack_public_path__ + "static/media/monitor.4b5867c2.svg";